import React, { useState, useEffect } from "react";

function Calculation({ calculationData, onCalculationChange }) {
  const [formData, setFormData] = useState({
    currentTotalCTC: "0",
    currentFixedCTC: "0",
    currentVariableCTC: "0",
    ctcIncreasePercentage: "0",
    ctcType: localStorage.getItem("ctcType") || "Select",
    expectedCTC: localStorage.getItem("expectedCTC") || "0",
    isCTCNegotiable: localStorage.getItem("isCTCNegotiable") || "Yes",
  });

  const handleRadioChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
    localStorage.setItem(name, value); // Store the selected radio value in localStorage
  };

  useEffect(() => {
    calculateExpectedCTC();
  }, [formData.currentTotalCTC, formData.currentFixedCTC, formData.ctcIncreasePercentage, formData.ctcType]);

  const calculateExpectedCTC = () => {
    let calculatedCTC = 0;

    if (formData.ctcType === "currentFixedCTC") {
      calculatedCTC = formData.currentFixedCTC + (formData.ctcIncreasePercentage * formData.currentFixedCTC) / 100;
    } else if (formData.ctcType === "currentTotalCTC") {
      calculatedCTC = formData.currentTotalCTC + (formData.ctcIncreasePercentage * formData.currentTotalCTC) / 100;
    }
    // calculatedCTC = String(calculatedCTC);

    setFormData({
      ...formData,
      expectedCTC: calculatedCTC,
    });

    localStorage.setItem("expectedCTC", calculatedCTC);
    localStorage.setItem("ctcType", formData.ctcType);

    onCalculationChange({
      currentTotalCTC: formData.currentTotalCTC,
      currentFixedCTC: formData.currentFixedCTC,
      currentVariableCTC: formData.currentVariableCTC,
      ctcIncreasePercentage: formData.ctcIncreasePercentage,
      ctcType: formData.ctcType,
      calculatedCTC,
      isCTCNegotiable: formData.isCTCNegotiable,
    });
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: parseFloat(value),
    });
  };

  const handleCtcTypeChange = (e) => {
    const selectedCtcType = e.target.value;

    if (selectedCtcType === "Select") {
      return;
    }

    setFormData({
      ...formData,
      ctcType: selectedCtcType,
    });

    localStorage.setItem("ctcType", selectedCtcType);
  };

  return (
    <div>
      <div className="row mt-3">
        <div className="col-md-6">
          <div className="form-group">
            <label htmlFor="currentTotalCTC">Current Total CTC:</label>
            <input
              type="number"
              id="currentTotalCTC"
              name="currentTotalCTC"
              value={formData.currentTotalCTC}
              onChange={handleInputChange}
              className="form-control"
            />
          </div>
        </div>
        <div className="col-md-6">
          <div className="form-group">
            <label htmlFor="currentFixedCTC">Current Fixed CTC:</label>
            <input
              type="number"
              id="currentFixedCTC"
              name="currentFixedCTC"
              value={formData.currentFixedCTC}
              onChange={handleInputChange}
              className="form-control"
            />
          </div>
        </div>
      </div>
      <div className="row mt-3">
        <div className="col-md-6">
          <div className="form-group">
            <label htmlFor="currentVariableCTC">Current Variable CTC:</label>
            <input
              type="number"
              id="currentVariableCTC"
              name="currentVariableCTC"
              value={formData.currentVariableCTC}
              onChange={handleInputChange}
              className="form-control"
            />
          </div>
        </div>
        <div className="col-md-6">
          <div className="form-group">
            <label htmlFor="ctcIncreasePercentage">CTC Increase In Percentage:</label>
            <input
              type="number"
              id="ctcIncreasePercentage"
              name="ctcIncreasePercentage"
              value={formData.ctcIncreasePercentage}
              onChange={handleInputChange}
              className="form-control"
            />
          </div>
        </div>
      </div>
      <div className="row mt-3">
        <div className="col-md-6">
          <div className="form-group">
            <label htmlFor="ctcType">CTC Increase In Percentage Based On:</label>
            <select
              id="ctcType"
              name="ctcType"
              value={formData.ctcType}
              onChange={handleCtcTypeChange}
              className="form-control"
            >
              <option value="Select">Select</option>
              <option value="currentTotalCTC">Current Total CTC</option>
              <option value="currentFixedCTC">Current Fixed CTC</option>
            </select>
          </div>
        </div>
        <div className="col-md-6">
          <div className="form-group">
            <label>Expected CTC:</label>
            <input
              type="text"
              value={formData.expectedCTC}
              readOnly
              className="form-control"
            />
          </div>
        </div>
      </div>
      <div className="row mt-3">
        <div className="col-md-6">
          <div className="form-group">
            <label htmlFor="isCTCNegotiable">Is CTC Negotiable:</label>
            <div style={{ display: "flex" }}>
              <div style={{ marginRight: "10px" }}>
                <input
                  type="radio"
                  id="ctcNegotiableYes"
                  name="isCTCNegotiable"
                  value="Yes"
                  checked={formData.isCTCNegotiable === "Yes"}
                  onChange={handleRadioChange}
                />
                <label htmlFor="ctcNegotiableYes">Yes</label>
              </div>
              <div>
                <input
                  type="radio"
                  id="ctcNegotiableNo"
                  name="isCTCNegotiable"
                  value="No"
                  checked={formData.isCTCNegotiable === "No"}
                  onChange={handleRadioChange}
                />
                <label htmlFor="ctcNegotiableNo">No</label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Calculation;